import React from "react";
import { MetaColetivaStats } from "../types";

interface NotasCardsProps {
  metaColetiva: MetaColetivaStats;
}

export const NotasCards: React.FC<NotasCardsProps> = ({ metaColetiva }) => {
  return (
    <div className="mb-4 grid grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-3 lg:grid-cols-5">
      <div className="rounded-lg border border-emerald-400/30 bg-slate-700/80 p-2 shadow-lg transition-colors hover:bg-slate-700 sm:p-4">
        <div className="text-center">
          <h3 className="mb-1 text-xs font-medium text-emerald-300">
            INICIALIZAÇÃO
          </h3>
          <div className="flex h-9 w-full items-center justify-center rounded border border-emerald-400/40 bg-slate-800/50 text-center text-lg font-bold text-white sm:h-10 sm:text-2xl">
            {metaColetiva.inicializacaoNota.toFixed(1)}
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-blue-400/30 bg-slate-700/80 p-2 shadow-lg transition-colors hover:bg-slate-700 sm:p-4">
        <div className="text-center">
          <h3 className="mb-1 text-xs font-medium text-blue-300">PRODUÇÃO</h3>
          <div className="flex h-9 w-full items-center justify-center rounded border border-blue-400/40 bg-slate-800/50 text-center text-lg font-bold text-white sm:h-10 sm:text-2xl">
            {metaColetiva.producaoNota.toFixed(1)}
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-amber-400/30 bg-slate-700/80 p-2 shadow-lg transition-colors hover:bg-slate-700 sm:p-4">
        <div className="text-center">
          <h3 className="mb-1 text-xs font-medium text-amber-300">
            FINALIZAÇÃO
          </h3>
          <div className="flex h-9 w-full items-center justify-center rounded border border-amber-400/40 bg-slate-800/50 text-center text-lg font-bold text-white sm:h-10 sm:text-2xl">
            {metaColetiva.finalizacaoNota.toFixed(1)}
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-purple-400/30 bg-slate-700/80 p-2 shadow-lg transition-colors hover:bg-slate-700 sm:p-4">
        <div className="text-center">
          <h3 className="mb-1 text-xs font-medium text-purple-300">TEMPO</h3>
          <div className="flex h-9 w-full items-center justify-center rounded border border-purple-400/40 bg-slate-800/50 text-center text-lg font-bold text-white sm:h-10 sm:text-2xl">
            {metaColetiva.tempo}
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-red-400/30 bg-slate-700/80 p-2 shadow-lg transition-colors hover:bg-slate-700 sm:p-4">
        <div className="text-center">
          <h3 className="mb-1 text-xs font-medium text-red-300">ERROS</h3>
          <div className="flex h-9 w-full items-center justify-center rounded border border-red-400/40 bg-slate-800/50 text-center text-lg font-bold text-white sm:h-10 sm:text-2xl">
            {metaColetiva.erroProducao}
          </div>
        </div>
      </div>
    </div>
  );
};
